<form [formGroup]="updateStatusForm" (ngSubmit)="onUpdateStatus()" #pTypeForm>
  <div class="main-card">
    <div class="card-header">
      <a class="main-btn back-btn" [routerLink]="['./../']"
        ><i class="pi pi-angle-left m-0"></i
      ></a>
      <button
        class="main-btn"
        type="submit"
        [ngClass]="{ disabled: !updateStatusForm.valid }"
        [disabled]="!updateStatusForm.valid"
      >
        Snimi <i class="pi pi-save"></i>
      </button>
    </div>
    <h3 class="card-title">Dodaj status</h3>
    <div class="card-body">
      <div class="grid">
        <div class="col-4">
          <div class="field w-100">
            <label>Oznaka statusa</label>
            <input
              type="text"
              class="w-100"
              formControlName="label"
              pInputText
            />
          </div>

          <div class="field w-100">
            <label>Naziv statusa</label>
            <input
              type="text"
              class="w-100"
              formControlName="name"
              pInputText
            />
          </div>

          <!-- <div class="field w-100">
            <label>Boja</label>
            <p-dropdown #operationId [options]="allColors" optionLabel="name" placeholder="Izaberi boju" formControlName="color" optionValue="hexColor"></p-dropdown>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</form>
